<nav compact tuiSubheader [style.position]="'sticky'" class="bg-white">
    <tui-breadcrumbs [itemsLimit]="10">
        <ng-container *ngFor="let item of breadcrumbs; let last = last">
            <ng-container *ngIf="last; else notLast">
                <strong *tuiItem tuiFade>
                    {{ item.label }}
                </strong>
            </ng-container>
            <ng-template #notLast>
                <button *tuiItem tuiLink type="button" (click)="navigate(item.link)" [disabled]="!item.link">
                    {{ item.label }}
                </button>
            </ng-template>
        </ng-container>
    </tui-breadcrumbs>
</nav>

<tui-loader [overlay]="true" [showLoader]="isLoading && !newUser" class="w-full block min-h-[400px]">

    <section class="w-full">
        <p class="text-4xl font-normal mt-[0.9rem]">{{newUser? 'Add New User':'Update User'}}</p>
        <form [formGroup]="userForm" (ngSubmit)="saveUser()">
            <div class="flex">
                <div>
                    <p class="text-base font-medium text-[#3E4A58] my-0">User Information</p>
                    <p class="text-sm font-normal text-[#949494D9] my-0 w-[225px]">Enter user Information</p>
                </div>
                <div class="w-full xl:w-1/3 2xl:w-1/3 pl-[6rem]">
                    <label tuiLabel class="mb-3">
                        <tui-input formControlName="name">User Name <input tuiTextfieldLegacy type="text" /></tui-input>
                        <tui-error formControlName="name" [error]="[] | tuiFieldError | async" />
                    </label>

                    <div *ngIf="!imageEditable">
                        <p class="text-sm font-normal text-[#949494D9]">Profile Picture</p>
                        <label tuiInputFiles class="mb-3">
                            <input #validator="tuiInputFilesValidator" accept="image/*" tuiInputFiles
                                [formControl]="control" [multiple]="true" (reject)="onReject($event)" placeholder=""
                                title="Profile Picture Input" />
                        </label>
                        <p class="text-red-600 py-0 my-0" *ngIf="userForm.get('profilePic')?.touched">
                            {{ getProfilePicError() }}
                        </p>

                        <tui-files class="tui-space_top-1 mb-3">
                            <tui-file *ngFor="let file of accepted$ | async" [file]="file" (remove)="onRemove(file)" />

                            <tui-file *ngFor="let file of rejected" state="error"
                                [file]="(file | tuiFileRejected: validator | async) || file"
                                (remove)="onRemove(file)" />
                        </tui-files>
                    </div>
                    <div *ngIf="imagePreview" class="mb-3 flex items-center space-x-3">
                        <div>
                            <p class="text-sm font-normal text-[#949494D9] mt-0 pt-0">Profile Picture Preview</p>
                            <img [src]="imagePreview" alt="Profile Picture Preview"
                                class="w-16 h-16 object-cover rounded-full border" />
                        </div>
                        <div *ngIf="!newUser">
                            <button tuiButton type="button" size="m" appearance="outline" (click)="editImage()"
                                class="mt-5">
                                Edit
                            </button>
                        </div>
                    </div>

                    <tui-error [error]="['maxLength'] | tuiFieldError | async" [formControl]="control" />
                    <label tuiLabel>
                        <tui-input formControlName="email">Email Address <input tuiTextfieldLegacy
                                type="email" /></tui-input>
                        <tui-error formControlName="email" class="mb-3" [error]="[] | tuiFieldError | async" />
                    </label>
                    <label tuiLabel>
                        <tui-input formControlName="contactNo">Phone Number <input tuiTextfieldLegacy
                                type="email" /></tui-input>
                        <tui-error formControlName="contactNo" [error]="[] | tuiFieldError | async" />
                    </label>

                </div>

            </div>
            <div class="flex">
                <div class="mt-5">
                    <p class="text-base font-medium text-[#3E4A58] my-0">Notes</p>
                    <p class="text-sm font-normal text-[#949494D9] my-0">(Optional)</p>
                </div>
                <div class="pl-[260px] w-full xl:w-1/3 2xl:w-1/3">
                    <label tuiLabel class="mt-5">
                        <tui-textarea formControlName="notes" [tuiTextfieldLabelOutside]="true"
                            placeholder="Enter Notes" title="Textarea Input">Start Typing...</tui-textarea>
                    </label>
                </div>

            </div>
            <div class="flex">
                <div class="inline-block mt-5">
                    <p class="text-base font-medium text-[#3E4A58] my-0">Access Control</p>
                    <p class="text-sm font-normal text-[#949494D9] my-0 w-[225px]">Vel cras auctor at tortor imperdiet
                        amet
                        id sed
                        rhoncus.</p>
                </div>
                <div class="w-full xl:w-1/3 2xl:w-1/3 mt-5 pl-[95px]">
                    <span class="inline-block w-full">
                        <tui-combo-box formControlName="role" [stringify]="stringify"
                            [identityMatcher]="roleIdentityMatcher" [tuiTextfieldLabelOutside]="true"
                            placeholder="Select Role">

                            <tui-data-list-wrapper *tuiDataList [itemContent]="stringify | tuiStringifyContent"
                                [items]="roles | tuiFilterByInput" />Select Role
                        </tui-combo-box>
                    </span>

                    <div class="flex items-center mt-5 space-x-4">
                        <input tuiSwitch type="checkbox" formControlName="active" placeholder="" title="Switch Input"
                            class="mt-5" />

                        <div>
                            <p class="text-sm font-normal text-[#3E4A58] my-0">Access Control</p>
                            <p class="text-xs font-normal text-[#A4A4A4] my-0">Vel cras auctor at tortor imperdiet amet
                                id
                                sed
                                rhoncus.</p>

                        </div>
                    </div>
                    <div class="mt-5 space-x-5 flex justify-end">
                        <button [routerLink]="['/admin/users']" appearance="outline" tuiButton type="button">
                            Cancel
                        </button>

                        <button appearance="primary" tuiButton type="submit" class="w-[200px]" [disabled]="isLoading"
                            [appDisableUnlessPermission]="newUser ? 'USER_CREATE' : 'USER_UPDATE'">
                            <!-- Dynamic Text Logic -->
                            <ng-container *ngIf="!isSaving">
                                {{ newUser ? 'Save New User' : 'Update User' }}
                            </ng-container>

                            <ng-container *ngIf="isSaving">
                                {{ newUser ? 'Saving...' : 'Updating...' }}
                            </ng-container>
                        </button>
                    </div>
                </div>

            </div>

        </form>
    </section>
</tui-loader>